<template>
    <div class="empty-list-placeholder" :style="{width:width,margin:margin}">
        <el-image
            class="empty-img"
            :src="img"
            fit="fill"
        ></el-image>

        <div class="text">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import img from './assets/empty-list.png';

export default {
    props: {
        width: {
            type: [String,Number],
            default: '300px'
        },
        margin:{
            type: [String,Number],
            default: '150px auto'
        }
    },
    data() {
        return {
            img,
        };
    },
};
</script>

<style lang="scss" scoped>
    .empty-list-placeholder {
        width: 300px;
        margin: 40px auto;

        .empty-img {
            width: 100%;
        }

        .text{
            text-align: center;
            font-size: 16px;
            color: #bbb;
            font-weight: bold;
        }
    }
</style>